import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environment/environment';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { DataImportsService } from '../_services/data-imports.service';
import { DataImport } from '../_types/data-import';

const TYPE_LABELS: Record<string, string> = {
    Expedientes: 'Expedientes', Incidencias: 'Incidencias', Notas: 'Notas',
    Operarios: 'Operarios', Trabajos: 'Trabajos', Visitas: 'Visitas'
};
const STATUS_LABELS: Record<string, string> = {
    Pendiente: 'Pendiente', EnCurso: 'En curso', Completada: 'Completada', Error: 'Error'
};
const STATUS_SEVERITY: Record<string, 'info' | 'warn' | 'success' | 'danger'> = {
    Pendiente: 'info', EnCurso: 'warn', Completada: 'success', Error: 'danger'
};
const MODE_LABELS: Record<string, string> = {
    Crear: 'Crear', CrearActualizar: 'Crear y actualizar'
};

@Component({
    selector: 'app-imports-list',
    templateUrl: './imports-list.component.html',
    styleUrls: ['./imports-list.component.scss'],
    providers: [ConfirmationService],
    standalone: false
})
export class ImportsListComponent implements OnInit, OnDestroy {
    imports: DataImport[] = [];
    showCreate = false;
    loading = false;
    allowWrite = false;
    allowDelete = false;
    private pollTimer: any;

    typeLabels = TYPE_LABELS;
    statusLabels = STATUS_LABELS;
    statusSeverity = STATUS_SEVERITY;
    modeLabels = MODE_LABELS;

    constructor(
        private service: DataImportsService,
        private router: Router,
        private loginService: LoginService,
        private confirmation: ConfirmationService,
        private topbarService: TopbarService
    ) {}

    ngOnInit(): void {
        this.topbarService.setTitle('Importaciones');
        this.allowWrite = this.loginService.hasPermission('IMPORTS.WRITE');
        this.allowDelete = this.loginService.hasPermission('IMPORTS.DELETE');
        this.load();
        this.pollTimer = setInterval(() => this.load(true), 5000);
    }

    ngOnDestroy(): void {
        if (this.pollTimer) clearInterval(this.pollTimer);
    }

    load(silent = false): void {
        if (!silent) this.loading = true;
        this.service.all({ sort: ['-createdAt'] } as any, silent).subscribe({
            next: (res: any) => {
                this.imports = res?.data ?? [];
                this.loading = false;
            },
            error: () => { this.loading = false; }
        });
    }

    openDetail(id: string): void {
        this.router.navigate(['/imports', id]);
    }

    downloadFile(fileId: string): void {
        window.open(`${environment.api_gw}common/files/${fileId}/download`, '_blank');
    }

    onCreated(): void {
        this.showCreate = false;
        this.load();
    }

    askDelete(row: DataImport): void {
        this.confirmation.confirm({
            header: 'Eliminar importación',
            message: '¿Eliminar también el fichero Excel asociado?',
            acceptLabel: 'Sí, eliminar todo',
            rejectLabel: 'Solo la importación',
            accept: () => this.doDelete(row.id!, true),
            reject: () => this.doDelete(row.id!, false)
        });
    }

    private doDelete(id: string, deleteFile: boolean): void {
        const url = `${environment.api_gw}common/dataImports/${id}?deleteFile=${deleteFile}`;
        (this.service as any).http.delete(url).subscribe({
            next: () => this.load(),
            error: (err: any) => alert('Error eliminando: ' + (err?.error?.errors?.[0]?.message ?? err?.message ?? 'sin detalle'))
        });
    }
}
